import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { Grid } from 'semantic-ui-react';
import { Chevron } from '../Chevron';
import { LinearGauge } from '../LinearGauge';
import { MiniPie } from '../MiniPie';
import { SortDirection, SortCriterion } from '../ListSortOptions';
import * as API from '../../API';
import './SectorResultGrid.scss';
export const SectorResultGrid = ({ className, knr, listPositions, sortBy = SortCriterion.ranking, sortDir = SortDirection.asc }) => {
    const infoRef = useRef(null);
    const sectorResultRef = useRef([]);
    const [mostRecentYear, setMostRecentYear] = useState(null);
    useEffect(() => {
        API.mostRecentYear()
            .then(mry => setMostRecentYear(mry));
    }, []);
    const { data: municipalitySectorResultsData } = useQuery(`kb/kommuner/sektorresultater/${knr}/${mostRecentYear}`, () => API.fetchMunicipalitySectorResults(knr));
    const { data: municipalityInfoData } = useQuery(`kb/kommuner/${mostRecentYear}/${knr}`, () => API.fetchMunicipalityInfo(knr));
    if (municipalityInfoData) {
        infoRef.current = municipalityInfoData;
    }
    const defaultSort = (a, b) => {
        const [l, r] = sortDir === SortDirection.asc ? [a, b] : [b, a];
        return sortDir === SortDirection.asc
            ? b.sektornavn.localeCompare(a.sektornavn, 'no-NO')
            : a.sektornavn.localeCompare(b.sektornavn, 'no-NO');
    };
    const sectorSort = (a, b) => {
        if (sortBy === SortCriterion.label) { // Already sorted by default
            return 0;
        }
        const [l, r] = sortDir === SortDirection.asc ? [a, b] : [b, a];
        return sortBy === SortCriterion.weight
            ? l.sektor_vekting - r.sektor_vekting
            : l.rangering - r.rangering;
    };
    if (municipalitySectorResultsData) {
        sectorResultRef.current = Object.values(municipalitySectorResultsData);
        sectorResultRef.current.sort(defaultSort).sort(sectorSort);
    }
    const sectorResults = Object.values(sectorResultRef.current);
    const jsxSectors = sectorResults.slice().map((sec, index) => {
        var _a, _b, _c;
        const w = sec.sektor_vekting;
        const p = Math.round(sec.sektor_vekting * 100);
        const rank = sortDir === SortDirection.asc
            ? index + 1
            : sectorResults.length - index;
        const jsxListPosition = sortBy === SortCriterion.ranking
            ? _jsx("i", { className: "badge rank", children: rank })
            : _jsx(MiniPie, { value: w, label: `${p}%`, className: "badge weight" });
        return (_jsxs("a", { className: `sector-result ${sec.sektorkode}`, title: `Klikk for flere detaljer om hvordan ${(_a = infoRef.current) === null || _a === void 0 ? void 0 : _a.kommune_navn} gjorde det innen ${(_b = sec.sektornavn) === null || _b === void 0 ? void 0 : _b.toLocaleLowerCase()}`, href: `#kommuner/${(_c = infoRef.current) === null || _c === void 0 ? void 0 : _c.kommune_knr}/sektorer/${sec.sektorkode}`, children: [jsxListPosition, _jsx("div", { className: "info", children: _jsx(LinearGauge, { label: _jsxs(_Fragment, { children: [sec.sektornavn, " ", _jsx(Chevron, { direction: "right" })] }), value: sec.rangering, max: 357, ranking: true, inverted: true }, `secor-result-griditem-${sec.sektorkode}`) })] }, sec.sektorkode));
    });
    let listPosition = 0;
    let rowCount = 0;
    let jsxSectorsColumns = [];
    const jsxSectorsRows = [];
    for (listPosition = 1; listPosition < jsxSectors.length + 1; listPosition++) {
        const childKey = jsxSectors[listPosition - 1].key;
        jsxSectorsColumns.push(_jsx(Grid.Column, { className: "sector-result-grid", children: jsxSectors[listPosition - 1] }, childKey));
        if ((jsxSectorsColumns.length % 3) === 0) {
            jsxSectorsRows.push(_jsx(Grid.Row, { children: jsxSectorsColumns }, `row${++rowCount}`));
            jsxSectorsColumns = [];
        }
    }
    if (jsxSectorsColumns.length > 0) {
        jsxSectorsRows.push(_jsx(Grid.Row, { children: jsxSectorsColumns }, `row${++rowCount}`));
    }
    const clsx = ['sector-result-grid', className !== null && className !== void 0 ? className : ''].join(' ');
    return (_jsx(Grid, { stackable: true, columns: 3, width: 16, className: clsx, children: jsxSectorsRows }));
};
